
import React, { useState } from 'react';

export const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 max-w-full overflow-hidden">
        <div className="flex items-center justify-between min-w-0">
          {/* ロゴ */}
          <div className="flex items-center flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/73be6e95a9cc4159c8afb514f102f80a.png" 
              alt="訪問介護のんな福島" 
              className="h-8 sm:h-10 md:h-12 w-auto max-w-full"
            />
          </div>

          {/* ナビゲーション */}
          <nav className="hidden lg:flex space-x-6 xl:space-x-8 flex-shrink-0">
            <a href="#about" className="text-base xl:text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer whitespace-nowrap">
              私たちについて
            </a>
            <a href="#services" className="text-base xl:text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer whitespace-nowrap">
              サービス内容
            </a>
            <a href="#recruitment" className="text-base xl:text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer whitespace-nowrap">
              求人情報
            </a>
            <a href="#contact" className="text-base xl:text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer whitespace-nowrap">
              お問い合わせ
            </a>
          </nav>

          {/* 電話番号 */}
          <div className="hidden md:flex items-center space-x-3 lg:space-x-4 flex-shrink-0">
            <div className="text-right min-w-0">
              <div className="text-xs lg:text-sm text-gray-600 leading-tight whitespace-nowrap">お気軽にお電話ください</div>
              <a href="tel:024-563-7717" className="text-lg lg:text-xl font-bold text-pink-600 hover:text-pink-700 whitespace-nowrap">
                024-563-7717
              </a>
            </div>
            <div className="w-6 h-6 lg:w-8 lg:h-8 flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-fill text-pink-600 text-xl lg:text-2xl"></i>
            </div>
          </div>

          {/* モバイル電話番号 */}
          <div className="md:hidden flex-shrink-0">
            <a href="tel:024-563-7717" className="flex items-center space-x-2 text-pink-600 hover:text-pink-700">
              <i className="ri-phone-fill text-xl"></i>
              <span className="text-sm font-semibold whitespace-nowrap">024-563-7717</span>
            </a>
          </div>

          {/* モバイルメニューボタン */}
          <button 
            className="lg:hidden p-2 ml-2 flex-shrink-0"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* モバイルメニュー */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <a 
                href="#about" 
                className="text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                私たちについて
              </a>
              <a 
                href="#services" 
                className="text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                サービス内容
              </a>
              <a 
                href="#recruitment" 
                className="text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                求人情報
              </a>
              <a 
                href="#contact" 
                className="text-lg text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                お問い合わせ
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
